import authApi from 'api/authApi';
import { removeAxiosAccessToken } from 'api/axiosClient';
import store from 'app/store';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import _ from 'lodash';
import { thunkLogIn } from './authSlice';
import ToastHelper from 'general/helpers/ToastHelper';

const AuthHelper = {
  // ---- methods ----
  callApiLogIn: (params) => {
    store.dispatch(thunkLogIn(params));
  },

  checkAccessTokenValid: () => {
    const accessToken = localStorage.getItem(PreferenceKeys.accessToken);
    return !_.isUndefined(accessToken) && !_.isNull(accessToken);
    return false;
  },

  signOut: () => {
    localStorage.removeItem(PreferenceKeys.accessToken);
    localStorage.removeItem(PreferenceKeys.accessTokenExpired);
    removeAxiosAccessToken();
  },

  callApiChangePassword: async (params) => {
    const res = await authApi.changePassword(params);
    return res;
  },
};

export default AuthHelper;
